import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
/** We have to wrap this badge with a tooltip outside of da-ds since tooltips still live in da-shared-react */ const PromoBadgeWithTooltip = (_param)=>{
    var { isLocked } = _param, rest = _object_without_properties(_param, [
        "isLocked"
    ]);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SimpleTooltip, {
        placement: "bottom",
        text: t(isLocked ? 'promoBadge.locked.tooltip' : 'promoBadge.unlocked.tooltip')
    }, /*#__PURE__*/ React.createElement(PromoBadge, _object_spread({
        isLocked: isLocked
    }, rest)));
};
PromoBadgeWithTooltip.displayName = 'PromoBadgeWithTooltip';
export default PromoBadgeWithTooltip;

//# sourceMappingURL=PromoBadgeWithTooltip.js.map